import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import styled from 'styled-components';
import { ModalDefaultDraggable } from '../../molecules';
import { dispatch } from '../../redux/store';
import { setSelectedGlossary } from '../../redux/slices/wikiSlice';
import { GlossaryDataType } from '../../api/jurisdiction';

const ConfirmationDialog = ({ confirmationOpen, setConfirmationOpen, confirmation, onOK, onCancel }) => {
    const onOKClicked = () => {
        setConfirmationOpen(false);
        onOK();
    };
    const onCancelClicked = () => {
        setConfirmationOpen(false);
        onCancel();
    };
  return (
    <div>
      {confirmationOpen && (
        <Wrapper>
          <ModalDefaultDraggable title="Confirmation" onClose={() => setConfirmationOpen(false)}>
            <p>{confirmation}</p>
            <br />
            <Buttons>
              <Button color="primary" variant="contained" onClick={onCancelClicked}>
                Cancel
              </Button>
              <Button color="primary" variant="contained" onClick={onOKClicked}>
                OK
              </Button>
            </Buttons>{' '}
          </ModalDefaultDraggable>
        </Wrapper>
      )}
    </div>
  );
};

export default ConfirmationDialog;

const Wrapper = styled.div`
  color: var(--primary);
  width: 100%;
  text-align: center;
`;

const Buttons = styled.div`
  display: flex;
  gap: 60px;
  margin-top: 30px;
  justify-content: center;
  button {
    width: 160px;
  }
`;
